import axiosWrapper from './axiosWrapper'

const URL_LOCALIDADES = `api/localidades`

const getLocalidadesProvincia = (axiosParams, data) => {
  const url = `${axiosParams.baseURL}/${URL_LOCALIDADES}`
  return axiosWrapper.post({ ...axiosParams, url }, data)
}

const serviceLocalidad = {
  getLocalidadesProvincia
}

export default serviceLocalidad
